'use client';

import { CURRENCY_COOKIE } from '@utils/currency';
import getCookie from '@utils/get-cookie';
import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';

const SelectCurrencyModal = dynamic(
  () =>
    import('./SelectCurrencyModal').then(
      (module) => module.SelectCurrencyModal
    ),
  { ssr: false }
);

export function CurrencyPreferencePrompt() {
  const [shouldLoad, setShouldLoad] = useState(false);

  useEffect(() => {
    setShouldLoad(!getCookie(CURRENCY_COOKIE));
  }, []);

  return shouldLoad ? <SelectCurrencyModal /> : null;
}
